<template lang="pug">
#startflow(v-loading="loading", element-loading-text="数据处理中...")
  .left(:class="{ showNode: showSteps }")
    .stageTitle
      .name 基本信息
      el-button.floatSteps(size="small", type="primary", plain, v-if="!showSteps", @click="queryApproveNodes") 查询处理人设置
    component(
      :is="basicForm",
      ref="businessForm",
      :flowMessage="flowMessage",
      :formId="flowMessage.formCode",
      :prjId="approvalPrjId",
      :flowDefinitionId="flowMessage.flowDefinitionId",
      @loadComplete="loadComplete",
      @change_showStartButtons="updateNodesEditor",
      @tableshow="tableshow",
      flowModeStatus="initiate"
      :key="comKey"
    )
    //- 兼容代码组件使用上传的展示文件列表，后期建议抛弃
    viewFileEditor(ref="viewFileEditor", :flowKey="flowKey", v-if="!isLowCode")

    template(v-if="fileList.length > 0")
      .uploaderTitle 流程附件
      viewFileList(ref="viewFileList", :files="fileList", noDelete)
    .check
      el-button(size="small", type="primary", plain, @click="queryFlowImage") 查询流程图
    .flowShowImage(v-if="showType === 'img'")
      el-image(:src="flowImage" :previewSrcList="[flowImage]")
  .right(v-if="showSteps")
    flowNodesEditor(ref="flowNodesEditor",:flowMessage="flowMessage", nodeType="preview",@updateNodesEditor="updateNodesEditor" @stepsClose="stepsClose")
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { getFormComponent } from "../config/flowFormRegister";
import customVform from "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue";
import flowNodesEditor from "../config/flowNodesEditor.vue";
import { getFlowImage } from "@/CommonDP/utils";
import { approveParams, addStartAttachedFiles, setPrjID, setEnablePrjSelector } from "../config";
import viewFileList from "../config/viewFileList.vue";
import viewFileEditor from "../config/viewFileEditor.vue";
import { getFormRequest } from "../config/flowFormRegister";
import { getFileInfoByFileIdAndVersion } from "@/CommonDP/service/vf-component-service";

export default {
  components: { viewFileList, flowNodesEditor, customVform, viewFileEditor },
  props: {
    // 是否为再发起的流程，是需要带入数据，否数据为空
    flowAgainAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      flowMessage: {},
      floderData: [],
      basicForm: "",
      showType: "", // user:处理人 ,img:流程图
      showSteps: false,
      comKey: 0,
      approvalPrjId: "",
      approvalProjectList: [],
      nodes: [],
      isDraftId: "" // 有数据说明是草稿
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    fileList() {
      return this.floderData.map((e) => {
        return {
          ...e,
          fileId: e.fileId,
          fileName: e.fileName
        };
      });
    },
    flowImage() {
      return getFlowImage(this.flowMessage.flowImage.slice(7));
    },
    prjId() {
      return this.$route.query.prjId || approveParams.prjId || this.prjInfo.prjId;
    },
    flowInstanceId() {
      return approveParams.detail.flowInstanceId;
    },
    version() {
      return approveParams.version;
    },
    definitionId() {
      return approveParams.definitionId;
    },
    flowKey() {
      return approveParams.flowKey;
    },
    routerParams() {
      return this.flowMessage;
    },
    // 是否低代码 true ：是
    isLowCode() {
      return this.flowMessage.customerForm === 2;
    },
    // 是否调用标准的流程接口:std 是 ，customize 否
    isMethodInvokeMode() {
      return approveParams.methodInvokeMode === "std";
    },
    urlFiles() {
      return JSON.parse(this.$route.query.list || "[]");
    }
  },
  watch: {
    prjId(newPrjId) {
      this.changeProject(newPrjId);
    }
  },
  methods: {
    async flowDetail(isDraftId) {
      this.isDraftId = isDraftId;
      this.loading = true;
      let res = "";
      try {
        if (this.isMethodInvokeMode) {
          res = await flowService.queryFlowDef(this.version, this.definitionId, this.flowKey);
        } else {
          const params = {
            flowVersionId: this.version,
            flowDefinitionId: this.definitionId,
            flowKey: this.flowKey
          };
          const url = getFormRequest().getRequestType(this.flowKey, "queryDetail", params);
          if (!url) {
            this.$message.warning(`该表单：${this.flowKey} 未配置对应的流程详情接口`);
            return false;
          }
          res = await url;
        }
        this.handleNextData(res.data || {});
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async handleNextData(data) {
      this.flowMessage = data || {};
      this.showType = "";
      this.floderData = data.attachedFiles || [];
      this.nodes = JSON.parse(data.nodes);
      this.comKey++;
      // 低代码设计的表单 默认属性
      if (this.isLowCode) {
        this.basicForm = customVform;
      } else {
        // 设置是否提供项目选择器
        setEnablePrjSelector(this.flowMessage.enablePrjSelector);
        setPrjID(this.prjId);
        const params = {
          ...data,
          name: data.flowName,
          prjId: this.approvalPrjId
        };
        this.$store.dispatch("setRouterParams", params);
        this.basicForm = getFormComponent(this.flowMessage.flowKey);
        if (this.flowAgainAdd) {
          this.getFormData();
        }
        await this.$nextTick();
        if (this.isDraftId) {
          this.$refs.businessForm.setFormData(approveParams.start.json);
        }
      }
      // cad rvt端发起流程带的参数
      const list = this.urlFiles;
      list.forEach((ele) => {
        ele.fileType = Number(ele.fileType);
      });
      this.$refs.viewFileEditor.setFileList(list || []);
      this.loading = false;
    },
    async loadComplete() {
      // 流程再发起操作
      if (this.flowAgainAdd) {
        this.getFormData();
        // 设置是否提供项目选择器
        setEnablePrjSelector(this.flowMessage.enablePrjSelector);
        // console.log("流程再发起");
        setPrjID(this.prjId);
      }
      if (this.isDraftId) {
        this.$refs.businessForm.setFormData(approveParams.start.json);
      }
      if (this.isLowCode) {
        const { urlFiles, $refs: { businessForm: { formData, setFormData }}} = this;
        const id = this.$refs.businessForm.getPrjId();
        setPrjID(formData[id]);
        const form = urlFiles.map(({ fileId, fileVersion: version }) => ({ fileId, version }));
        if (form?.length) {
          const { data } = await getFileInfoByFileIdAndVersion(form);
          setFormData({ ...formData, fileInfoList: data.map(({ ...f }, index) => ({ ...f, fileType: urlFiles[index]?.fileType })) });
        }
      }
    },
    // 获取数据信息
    async getFormData() {
      const res = await flowService.getBusinessForm(this.flowInstanceId);
      this.detailMessage = res.data || {};
      const formData = res.data.object || {};
      this.$refs.businessForm.setFormData(formData);
    },
    // 查询处理人设置
    async queryApproveNodes() {
      const validate = await this.startValidate();
      if (validate) {
        this.showSteps = !this.showSteps;
        await this.$nextTick();
        const params = await this.getBasicData();
        this.$refs.flowNodesEditor.stepsOpen(params);
      }
    },
    // 更新流程处理人
    async updateNodesEditor() {
      if (this.showSteps) {
        const params = await this.getBasicData();
        this.$refs.flowNodesEditor.stepsOpen(params);
      }
    },
    // 获取基本信息数据
    async getBasicData(needValidation = true) {
      return this.$refs.businessForm.getFormData(needValidation);
    },
    // 校验表单是否把必填项输入
    async startValidate() {
      // 低代码表单校验
      if (this.isLowCode) {
        return await this.$refs.businessForm.startValidate();
      } else {
        return await this.$refs.businessForm.validateFormData();
      }
    },
    // 切换项目
    async changeProject(prjId) {
      this.showSteps = false;
      // 适配兼容之前数据
      const params = {
        ...this.routerParams,
        name: this.routerParams.flowName,
        prjId
      };
      this.$store.dispatch("setRouterParams", params);
      this.comKey++;
    },
    // 通用组件关联文件夹
    tableshow(val) {
      addStartAttachedFiles(val);
    },
    // 校验并获取节点信息
    async startApproval() {
      const validate = await this.startValidate();
      if (validate) {
        const params = await this.getBasicData();
        return params;
      } else {
        return null;
      }
    },
    // 查询处理人发起流程
    async queryFlowNodeList(param) {
      const params = {
        flowDefinitionId: this.flowMessage.flowDefinitionId,
        flowDefinitionVersionId: this.version,
        flowKey: this.flowKey,
        enterpriseId: this.enterpriseId,
        param,
        prjId: approveParams.formType === 1 ? this.prjId : ""
      };
      const res = await flowService.queryFlowNodeList(params);
      return res.data || [];
    },
    queryFlowImage() {
      this.showType = "img";
    },
    openRight() {
      this.showSteps = true;
    },
    stepsClose() {
      this.showSteps = false;
    }
  }
};
</script>

<style lang="scss" scoped>
#startflow {
  width: 100%;
  height: 600px;
  padding: 0 10px;
  display: flex;
  flex-direction: row;

  .left {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 10px;
    transition: all 0.3s;
  }

  .showNode {
    width: calc(100% - 400px);
    transition: all 0.3s;
  }

  .right {
    width: 400px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    transition: all 0.3s;
  }

  .stageTitle {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid #ebefff;
    margin-bottom: 10px;

    .name {
      font-weight: 700;
      font-size: 16px;
      line-height: 40px;
      color: var(--theme-color);
    }

    .prjList {
      margin-left: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    span {
      font-size: 14px;
      line-height: 40px;
    }

    .floatSteps {
      margin-left: auto;
    }
  }
}

.uploaderTitle {
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ebefff;
  margin-bottom: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 40px;
  color: var(--theme-color);
}

.check {
  margin-top: 5px;
  height: 45px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flowShowImage {
  width: 100%;

  img {
    width: 100%;
    object-fit: contain;
  }
}
</style>
